import { connect } from 'react-redux';
import AdminMonthlyGoalsPage from 'pages/AdminMonthlyGoalsPage';
import AdminActions from 'store/adminPanel/actions';

const mapStateToProps = state => {
  return {
    isAddGoalsRequesting: state.adminPanel.isAddGoalsRequesting,
    isGoalsAdded: state.adminPanel.isGoalsAdded,
    adminPreviousgoals: state.adminPanel.adminPreviousgoals,
    isPreviousGoalsLoading: state.adminPanel.loadingPreviousGoals
  };
};
const mapDispatchToProps = {
  adminAddGoals: AdminActions.Creators.adminAddGoalsRequest,
  loadPrevoiusGoals: AdminActions.Creators.adminGetGoalsRequest
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminMonthlyGoalsPage);
